module.exports = __webpack_public_path__ + "img/anticlockwise_ac.9d47aa4a.png";